import { SCALE } from "../../utils/constants";

class Arrow {
  constructor(scene) {
    this.scene = scene;
    // Creating a blank tilemap
    this.map = this.scene.make.tilemap({ tileWidth: 20, tileHeight: 20, width: 3, height: 1 });
  }

  getArrow() {
    const map = this.map
    // addTilesetImage: function (tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid)
    let tileset = map.addTilesetImage('arrows', 'hud-tiles', 20, 20, 1, 2);
    let layer = map.createBlankLayer('layer_arrow', tileset);
    layer.name = 'layer_arrow'
    layer.depth = 15
    layer.setScrollFactor(0)
    layer.setScale(SCALE)
    
    return map.putTileAt(30, 0, 0);
  }
  
  getArrowDown() {
    const tile = this.getArrow()
    return tile
  }
  getArrowRight() {
    const tile = this.getArrow()
    tile.rotation = -Math.PI/2
    return tile
  }
  getArrowUp() {
    const tile = this.getArrow()
    tile.rotation = Math.PI
    return tile
  }
  getArrowLeft() {
    const tile = this.getArrow()
    tile.rotation = Math.PI/2
    return tile
  }
}

export default Arrow